export default "__VITE_ASSET__96cbfeed__"